import axios from 'axios';
import { resolveBackendBaseUrl } from '../lib/wsAuth';

const RESERVED_SEGMENTS = ['auth', 'app', 'admin', 'api', 'staff', 'staff-portal', 'finance', 'referral-staff', 'agent'];
const PLATFORM_DOMAIN = (process.env.REACT_APP_PLATFORM_DOMAIN || 'vegaslobby.vip').toLowerCase();

const getTenantSlug = () => {
  const path = window.location.pathname;
  const match = path.match(/^\/([a-z0-9-]+)\//i);
  if (match && !RESERVED_SEGMENTS.includes(match[1])) return match[1];
  const host = (window.location.hostname || '').toLowerCase().replace(/^www\./, '');
  const suffix = `.${PLATFORM_DOMAIN}`;
  if (host.endsWith(suffix)) {
    const slug = host.slice(0, -suffix.length);
    if (slug && !RESERVED_SEGMENTS.includes(slug)) return slug;
  }
  return null;
};

const api = axios.create({
  baseURL: resolveBackendBaseUrl(),
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('session_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const tenantSlug = getTenantSlug();
  if (tenantSlug) config.headers['X-Tenant-Slug'] = tenantSlug;
  // Auto-generate idempotency key for POST requests
  if (config.method === 'post' && !config.headers['X-Idempotency-Key']) {
    config.headers['X-Idempotency-Key'] = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('session_token');
      const path = window.location.pathname;
      const isProtected = path.startsWith('/app') || path.startsWith('/admin') || path.match(/^\/[^/]+\/(app|admin)/);
      if (isProtected) {
        const slug = getTenantSlug();
        window.location.href = slug ? `/${slug}/auth` : '/auth';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
